import React, { useContext, useState } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import PrimaryButton from '../../Components/Button/PrimaryButton'
import SmallSpinner from '../../Components/Spinner/SmallSpinner'
import { AuthContext } from '../../contexts/AuthProvider'
import { setAuthToken } from '../../api/auth'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'

const Login = () => {
  const [userEmail, setUserEmail] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [step, setStep] = useState(1)  // Track which step the user is on
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [isVerified, setIsVerified] = useState(false)
  const { signin } =
  useContext(AuthContext)
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'

  const sendVerificationCode = async () => {
    try {
      setLoading(true)
      const response = await axios.post('https://mirai-server.vercel.app/verify-email', { email: userEmail })
      if (response.data.message) {
        toast.success(response.data.message)
        setStep(2)  // Move to step 2
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      toast.error('Failed to send verification code.')
    }
  }

  const verifyCode = async () => {
    try {
      setLoading(true)
      const response = await axios.post('https://mirai-server.vercel.app/submit-code', { email: userEmail, code: verificationCode })
      if (response.data.message) {
        setIsVerified(true)
        toast.success('Verification successful!')
        setStep(3)  // Move to step 3
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      toast.error('Invalid verification code.')
    }
  }

  // const handleSubmit = event => {
  //   event.preventDefault()
  //   const email = userEmail
  //   const password = event.target.password.value

  //   signin(email, password)
  //     .then(result => {
  //       toast.success('Login Successful.....!')
  //       // Get Token
  //       setLoading(false)
  //       setAuthToken(result.user)
  //       navigate('/dashboard');
  //       window.location.reload();
  //     })
  //     .catch(err => {
  //       toast.error(err.message)
  //       console.log(err)
  //       setLoading(false)
  //     })
  // }

  const handleSubmit = (event) => {
    event.preventDefault();
    const email = userEmail; // Use the existing `userEmail` variable for email
    const password = event.target.password.value;
  
    signin(email, password)
      .then(async (result) => {
        toast.success('Login Successful.....!');
  
        // Set the token after successful sign-in
        try {
          const currentUser = { email: result.user.email };
          const response = await fetch(`https://mirai-server.vercel.app/user/${result.user.email}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(currentUser),
          });
  
          const data = await response.json();
          if (data?.token) {
            localStorage.setItem('aircnc-token', data.token);
            console.log('Token saved to local storage:', data.token);
          } else {
            console.error('Failed to retrieve token from response:', data);
          }
        } catch (error) {
          console.error('Error setting auth token:', error);
        }
  
        navigate('/dashboard');
        window.location.reload(); 
      })
      .catch((err) => {
        toast.error(err.message);
        console.error(err);
      });
  };
  

  return (
    <div className='flex justify-center items-center pt-8 h-screen'>
      <div className='flex flex-col max-w-md p-6 rounded-md sm:p-10 w-[40%] bg-white border border-gray-400 shadow-md'>
        <div className='mb-8 text-center'>
          <h1 className='my-3 text-2xl font-bold text-gray-900 font-jost'>
            {step === 1 ? 'Enter Your Email to Log-In' : step === 2 ? 'Enter Verification Code' : 'Create a Password'}
          </h1>
        </div>

        {step === 1 && (
          <form onSubmit={(e) => { e.preventDefault(); sendVerificationCode(); }}>
            <input
              type='email'
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              required
              placeholder='Enter your email'
              className='w-full px-3 py-2 border rounded-md font-jost bg-white border-gray-400'
            />
            <button type='submit' class='w-full px-8 py-3 mt-4 font-jost bg-blue-900 text-white'>
              {loading ? <SmallSpinner /> : 'Send Code'}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={(e) => { e.preventDefault(); verifyCode(); }}>
            <input
              type='text'
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              required
              placeholder='Enter verification code'
              className='w-full px-3 py-2 border rounded-md bg-white border-gray-400 font-jost'
            />
            <button type='submit' class='w-full px-8 py-3 mt-4 font-jost bg-blue-900 text-white'>
              {loading ? <SmallSpinner /> : 'Verify Code'}
            </button>
          </form>
        )}

        {step === 3 && isVerified && (
           <form
           onSubmit={handleSubmit}
           noValidate=''
           action=''
           className='space-y-6 ng-untouched ng-pristine ng-valid'
         >
           <div className='space-y-4'>
             {/* <div>
               <label htmlFor='email' className='block mb-2 text-md font-roboto text-rose-800'>
                 Email address
               </label>
               <input
                 onBlur={event => setUserEmail(event.target.value)}
                 type='email'
                 name='email'
                 id='email'
                 required
                 placeholder='Enter Your Email Here'
                 className='w-full px-3 py-2 border rounded-md border-gray-300 focus:outline-green-500 bg-gray-200 text-gray-900'
                 data-temp-mail-org='0'
               />
             </div> */}
             <div>
               <div className='flex justify-between'>
                 <label htmlFor='password' className='text-sm mb-2 text-md font-roboto text-gray-900'>
                   Password
                 </label>
               </div>
               <input
                 type='password'
                 name='password'
                 id='password'
                 required
                 placeholder='*******'
                 className='w-full px-3 py-2 border rounded-md border-gray-300 focus:outline-green-500 bg-white text-gray-900'
               />
             </div>
           </div>
 
           <div>
             <button
               type='submit'
               class='w-full px-8 py-3 font-semibold rounded-md bg-blue-900   text-gray-100'
             >
               {loading ? <SmallSpinner /> : 'Sign in'}
             </button>
           </div>
         </form>
        )}

     
      </div>
    </div>
  )
}

export default Login
